import { Navigate } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

export default function NavGuard({ settingKey, children }) {
  const { settings, loaded } = useSettings();
  if (!loaded) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-void">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-cyan border-t-transparent" />
      </div>
    );
  }
  if (!settings[settingKey]) return <Navigate to="/" replace />;
  return children;
}
